// Dependencies
import React, { FunctionComponent } from 'react'

// Types
import { NeedHelpProps } from './need-help.types'

// Assets
import talkWithUs from '../../assets/talk-with-us.svg'

// Styles
import {
  Container,
  ContentWrapper,
  NeedHelpButton,
  NeedHelpButtonLabel,
  NeedHelpContentWrapper,
  NeedHelpIcon,
  NeedHelpSectionSubtitle,
  NeedHelpSectionTitle
} from './need-help.styles'

export const NeedHelp: FunctionComponent<NeedHelpProps> = ({
  title,
  subtitle,
  handleClick
}) => {
  return (
    <Container>
      <ContentWrapper>
        <NeedHelpIcon src={talkWithUs} />

        <NeedHelpContentWrapper>
          <NeedHelpSectionTitle>{title}</NeedHelpSectionTitle>

          <NeedHelpSectionSubtitle>{subtitle}</NeedHelpSectionSubtitle>
        </NeedHelpContentWrapper>
      </ContentWrapper>

      <NeedHelpButton onClick={handleClick}>
        <NeedHelpButtonLabel>Preciso de ajuda</NeedHelpButtonLabel>
      </NeedHelpButton>
    </Container>
  )
}
